export const AdminNav = [
  {
    icon: "pe-7s-graph2",
    label: "Dashboard",
    rbacModule: "dashboard",
    content: [
      {
        label: "Main Dashboard",
        to: "/dashboard",
        rbacModule: "dashboard",
        rbacAction: "read",
        superAdminOnly: true,
      },
      {
        label: "Sales & Earnings",
        to: "/admin/dashboard/sales-earnings",
        rbacModule: "analytics_dashboard",
        rbacAction: "read",
      },
      {
        label: "Inventory analytics",
        to: "/admin/inventory-analytics",
        rbacModule: "dashboard",
        rbacAction: "read",
        superAdminOnly: true,
      },
      {
        label: "Analytics Dashboard",
        to: "/admin/dashboard",
        rbacModule: "dashboard",
        rbacAction: "read",
        superAdminOnly: true,
      },
    ],
  },
  {
    icon: "pe-7s-cash",
    label: "Store Sales",
    rbacModule: "sale",
    content: [
      { label: "New sale", to: "/sales/add", rbacModule: "sale", rbacAction: "create" },
      { label: "Orders list", to: "/sales/list", rbacModule: "sale", rbacAction: "read" },
    ],
  },
  {
    icon: "pe-7s-shop",
    label: "Stores",
    rbacModule: "store",
    content: [
      {
        label: "All stores",
        to: "/store/list",
        rbacModule: "store",
        rbacAction: "read",
      },
    ],
  },
  {
    icon: "pe-7s-map-marker",
    label: "Pincodes",
    rbacModule: "store",
    to: "/pincode/list",
    rbacAction: "read",
  },
  {
    icon: "pe-7s-plugin",
    label: "Team / Staff",
    rbacModule: "staff",
    content: [
      { label: "Staff list", to: "/staff/list", rbacModule: "staff", rbacAction: "read" },
      { label: "Add staff", to: "/staff/create", rbacModule: "staff", rbacAction: "create" },
    ],
  },
  {
    icon: "pe-7s-clock",
    label: "Activity logs",
    rbacModule: "activity_log",
    to: "/activity-logs",
    rbacAction: "read",
  },
  {
    icon: "pe-7s-cash",
    label: "Price history",
    rbacModule: "price_history",
    to: "/price-history",
    rbacAction: "read",
  },
  {
    icon: "pe-7s-users",
    label: "Users",
    rbacModule: "user",
    to: "/user/list",
    rbacAction: "read",
    // content: [
    // {
    //   label: "Add Shop Admin",
    //   to: "/user/add/shopadmin",
    // },
    // {
    //   label: "Add User",
    //   to: "/user/add",
    // },
    // {
    // label: "List",
    // to: "/user/list",
    // },
    // ],
  },
  {
    icon: "pe-7s-search",
    label: "Search Logs",
    superAdminOnly: true,
    rbacModule: "order",
    to: "/search-logs/list",
    rbacAction: "read",
  },
  {
    icon: "pe-7s-shopbag",
    label: "Products",
    rbacModule: "product",
    content: [
      {
        label: "Add Product",
        to: "/product/add",
        rbacModule: "product",
        rbacAction: "create",
      },
      {
        label: "List",
        to: "/product/list",
        rbacModule: "product",
        rbacAction: "read",
      },
      {
        label: "Review moderation",
        to: "/admin/ratings",
        rbacModule: "product",
        rbacAction: "read",
        superAdminOnly: true,
      },
    ],
  },
  {
    icon: "pe-7s-network",
    label: "Categories",
    rbacModule: "category",
    content: [
      {
        label: "Add",
        to: "/category/add",
        rbacModule: "category",
        rbacAction: "create",
      },
      {
        label: "List",
        to: "/category/list",
        rbacModule: "category",
        rbacAction: "read",
      },
    ],
  },

  {
    icon: "pe-7s-medal",
    label: "Orders",
    rbacModule: "order",
    to: "/order/list",
    rbacAction: "read",
  },
  {
    icon: "pe-7s-repeat",
    label: "Refunds",
    rbacModule: "refund",
    to: "/refund/list",
    rbacAction: "read",
  },
  {
    icon: "pe-7s-chat",
    label: "Messages",
    rbacModule: "chat",
    to: "/chat/list",
    rbacAction: "read",
  },
  {
    icon: "pe-7s-user-female",
    label: "Referral Requests",
    rbacModule: "support",
    to: "/referrals/list",
    rbacAction: "read",
  },
  {
    icon: "pe-7s-gift",
    label: "Cashback & Referrals",
    rbacModule: "support",
    to: "/cashback",
    rbacAction: "read",
  },
  {
    icon: "pe-7s-loop",
    label: "Referral & Rewards",
    rbacModule: "support",
    content: [
      { label: "Settings", to: "/referral/settings", rbacModule: "support", rbacAction: "read" },
      { label: "Pending user approvals", to: "/referral/users/pending", rbacModule: "support", rbacAction: "read" },
      { label: "Eligible users", to: "/referral/users/eligible", rbacModule: "support", rbacAction: "read" },
      { label: "Pending rewards", to: "/referral/rewards/pending", rbacModule: "support", rbacAction: "read" },
      { label: "Statistics", to: "/referral/stats", rbacModule: "support", rbacAction: "read" },
    ],
  },
  {
    icon: "pe-7s-cup",
    label: "Rewards (campaigns)",
    rbacModule: "rating",
    content: [
      {
        label: "Add Campaign",
        to: "/reward/campaign/add",
        rbacModule: "rating",
        rbacAction: "create",
      },
      {
        label: "Campaign List",
        to: "/reward/campaign/list",
        rbacModule: "rating",
        rbacAction: "read",
      },
      {
        label: "Winner Preview",
        to: "/reward/winner/preview",
        rbacModule: "rating",
        rbacAction: "read",
      },
      {
        label: "Winner List",
        to: "/reward/winner/list",
        rbacModule: "rating",
        rbacAction: "read",
      },
    ],
  },
  // {
  //   icon: "pe-7s-photo",
  //   label: "Banners",
  //   rbacModule: "product",
  //   content: [
  //     {
  //       label: "Create Banner",
  //       to: "/banners/add",
  //     },
  //     {
  //       label: "Banner List",
  //       to: "/banners/list",
  //     },
  //   ],
  // },
  {
    icon: "pe-7s-cart",
    label: "Cart Viewer",
    rbacModule: "cart",
    to: "/cart/list",
    rbacAction: "read",
  },
  {
    icon: "pe-7s-note2",
    label: "Daily Ledger",
    rbacModule: "daily_entry",
    content: [
      { label: "Add entry", to: "/daily-ledger/add", rbacModule: "daily_entry", rbacAction: "create" },
      { label: "History", to: "/daily-ledger/history", rbacModule: "daily_entry", rbacAction: "read" },
      { label: "Dashboard", to: "/daily-ledger/dashboard", rbacModule: "daily_entry", rbacAction: "read" },
    ],
  },
  {
    icon: "pe-7s-id",
    label: "Payroll",
    rbacModule: "payroll",
    content: [
      { label: "Salary Management", to: "/payroll/salary", rbacModule: "payroll", rbacAction: "update" },
      { label: "Holidays", to: "/payroll/holidays", rbacModule: "payroll", rbacAction: "update" },
      {
        label: "Attendance",
        rbacModule: "payroll",
        content: [
          { label: "Mark Attendance", to: "/payroll/attendance", rbacModule: "payroll", rbacAction: "update" },
          { label: "My Attendance", to: "/payroll/me/attendance", rbacModule: "payroll", rbacAction: "read" },
        ],
      },
      { label: "Monthly Payroll", to: "/payroll/runs", rbacModule: "payroll", rbacAction: "update" },
      { label: "Employee Money", to: "/payroll/money", rbacModule: "payroll", rbacAction: "update" },
      { label: "Advances", to: "/payroll/advances", rbacModule: "payroll", rbacAction: "read" },
      { label: "My Money", to: "/payroll/me/money", rbacModule: "payroll", rbacAction: "read" },
    ],
  },
  {
    icon: "pe-7s-graph3",
    label: "Reports",
    rbacModule: "dashboard",
    content: [
      {
        label: "Earning by Product",
        to: "/reports/earning-by-product",
        rbacModule: "dashboard",
        rbacAction: "read",
      },
      {
        label: "Earning by User",
        to: "/reports/earning-by-user",
        rbacModule: "dashboard",
        rbacAction: "read",
      },
      {
        label: "Custom Report",
        to: "/reports/custom",
        rbacModule: "dashboard",
        rbacAction: "read",
      },
    ],
  },
  {
    icon: "pe-7s-mail",
    label: "Contact Us",
    rbacModule: "support",
    to: "/contact/list",
    rbacAction: "read",
  },
  {
    icon: "pe-7s-config",
    label: "Settings",
    rbacModule: "permission",
    to: "/settings/general",
    rbacAction: "read",
  },
  {
    icon: "pe-7s-key",
    label: "Permission management",
    content: [
      {
        label: "Overview",
        to: "/settings/permissions/overview",
        rbacModule: "permission",
        superAdminOnly: true,
      },
      {
        label: "Roles & how access works",
        to: "/settings/permissions/roles",
        rbacModule: "permission",
        superAdminOnly: true,
      },
      {
        label: "Staff by store",
        to: "/settings/permissions/staff",
        rbacModule: "permission",
        superAdminOnly: true,
      },
      {
        label: "Templates & API",
        to: "/settings/permissions/templates",
        rbacModule: "permission",
        superAdminOnly: true,
      },
    ],
  },
];

// https://demo.dashboardpack.com/architectui-html-pro/elements-icons.html